import React, { useRef, useState, useEffect } from 'react';
import TablaUuariosWebs from './tablaUsuariosWebs';

export const UsuarioWeb = (props) => {

    return (
        <div className='container-fluid rounded p-0 m-0'>
        <div className='container-fluid w-100 h-100 p-0 m-0'>
              <TablaUuariosWebs/>
           </div>
        </div>

    );
}


// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/usuariosWeb.js